var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "#AEB2BE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50098 7.78913C9.64385 7.78913 11.3955 6.03744 11.3955 3.89456C11.3955 1.75169 9.64385 0 7.50098 0C5.35811 0 3.60645 1.75169 3.60645 3.89456C3.60645 6.03744 5.35814 7.78913 7.50098 7.78913Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1843 10.9014C14.0822 10.6463 13.9462 10.4082 13.7931 10.1871C13.0108 9.03059 11.8033 8.26529 10.4428 8.07822C10.2727 8.06122 10.0857 8.09521 9.94959 8.19726C9.2353 8.72447 8.38497 8.99657 7.5006 8.99657C6.61622 8.99657 5.76589 8.72447 5.0516 8.19726C4.91554 8.09521 4.72846 8.0442 4.55841 8.07822C3.19786 8.26529 1.97338 9.03059 1.20808 10.1871C1.05502 10.4082 0.918954 10.6633 0.816936 10.9014C0.765927 11.0034 0.782919 11.1225 0.833928 11.2245C0.969996 11.4626 1.14005 11.7007 1.29311 11.9048C1.53119 12.2279 1.7863 12.517 2.07543 12.7891C2.31352 13.0272 2.58562 13.2483 2.85776 13.4694C4.20128 14.4728 5.81694 15 7.4836 15C9.15027 15 10.7659 14.4728 12.1094 13.4694C12.3816 13.2653 12.6537 13.0272 12.8918 12.7891C13.1639 12.517 13.436 12.2279 13.6741 11.9048C13.8442 11.6837 13.9972 11.4626 14.1333 11.2245C14.2183 11.1225 14.2353 11.0034 14.1843 10.9014Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.4f33d0b8e64b09b697a75e9c8295cb02.svg";